var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 5.10714C28 6.19192 27.1307 7.07143 26.0586 7.07143C26.0466 7.07143 26.0365 7.06519 26.0245 7.06504L23.5725 20.7119C23.4377 21.4549 22.797 22 22.0447 22H5.99896C5.2486 22 4.60503 21.4569 4.47107 20.71L2.01955 7.06652C2.00742 7.06652 1.99723 7.07143 1.94141 7.07143C0.869267 7.07143 0 6.19192 0 5.10714C0 4.02237 0.912948 3.14286 1.94141 3.14286C2.96987 3.14286 3.88282 4.02237 3.88282 5.10714C3.88282 5.54901 3.71193 5.93656 3.46848 6.2646L7.81869 9.78558C8.59089 10.4107 9.73584 10.156 10.178 9.26112L12.9736 3.60397C12.425 3.25777 12.0367 2.66848 12.0367 1.96429C12.0367 0.879509 12.9492 0 14.0218 0C15.0945 0 15.9196 0.879509 15.9196 1.96429C15.9196 2.66848 15.5331 3.25777 14.9828 3.60446L17.7785 9.26161C18.2207 10.1563 19.3661 10.4107 20.1378 9.78607L24.488 6.26509C24.2871 5.93705 24.1172 5.50491 24.1172 5.10714C24.1172 4.02187 24.986 3.14286 26.0586 3.14286C27.1312 3.14286 28 4.02187 28 5.10714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIconWhite);
export default __webpack_public_path__ + "static/media/premium-icon-white.c3e77ee063458c399987d3009429746d.svg";
export { ForwardRef as ReactComponent };